export default __webpack_public_path__ + "static/media/ei_example.2665e355.png";